



















































































import BaseComponent from '@/components/base-component.vue';
import UiDatePickerRange from '@/components/UI/date-picker-range.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectSortOptions from '@/components/UI/select-sort-options.vue';
import { listCrmVisitContacts, listCrmVisitVisitors } from '@/services/crm-visit';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import UiSelectInstitution from '../institution/select-institution.vue';

@Component({
  components: {
    PermissionAuth,
    UiFilterContainer,
    UiSelectSortOptions,
    UiSelectInstitution,
    UiDatePickerRange
  }
})
export default class VisitFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = {};

  descending = false;
  sortBy = '';
  sortOptions = [];

  visitors = [];
  visitContacts = [];

  mounted() {
    this.buildSortOptions();

    this.loadVisitors();
    this.loadContacts();
  }

  buildSortOptions() {
    this.descending = false;
    this.sortBy = 'inst.nomeFantasia';
    this.sortOptions = [];
    this.sortOptions.push({ text: 'Instituição', value: 'inst.nomeFantasia' });
    this.sortOptions.push({ text: 'Data', value: 'data' });
  }

  onSortChange(by, desc) {
    this.sortBy = by;
    this.descending = desc;
  }

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.emitFilter();
  }

  emitFilter() {
    if (this.menuMode) {
      this.filter.descending = this.descending;
      this.filter.sortBy = this.sortBy;
    } else {
      this.filter.sortBy = null;
    }
    this.$emit('filter', this.filter);
  }

  loadVisitors() {
    listCrmVisitVisitors().subscribe((res) => {
      this.visitors = res;
    });
  }

  loadContacts() {
    listCrmVisitContacts().subscribe((res) => {
      this.visitContacts = res;
    });
  }
}
